<template>
  <div id="app" class="affix-container" ref="scrollContainer">
      <div class="website-contact-container">
        <div class="contact-info">
          <div class="contact">
            <el-icon :size="16"><PhoneFilled /></el-icon>
            <span>{{paramsinfo.telphone}}</span>
          </div>
          <div class="contact-email contact">
            <el-icon :size="16"><Message /></el-icon>
            <span>{{paramsinfo.email}}</span>
          </div>
        </div>
        <div class="right-lang">
          <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            {{language.name?language.name:'语言加载中'}}
            <el-icon class="el-icon--right">
              <arrow-down />
            </el-icon>
          </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item v-for="item in languageList" :key="item.id" @click="changelanguage(item)">{{item.name}}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <div class="menu-index">
        <router-link to="/" :underline="false">
                    <img
                        style="width: 210px;margin-left: 40px;"

                        src="./assets/kswlogo-login.png"
                        alt="酷赛威"
                        class="logo-image"
                    />
        </router-link>
        <el-menu :default-active="activeIndex"
                 class="el-menu-demo"
                 mode="horizontal"
                 @select="handleSelect"
        >
<!--          <el-menu-item index="0">-->
<!--            <router-link to="/" :underline="false">-->
<!--            <img-->
<!--                style="width: 250px"-->
<!--                src="./assets/kswlogo-login.png"-->
<!--                alt="酷赛威"-->
<!--                class="logo-image"-->
<!--            />-->
<!--            </router-link>-->
<!--          </el-menu-item>-->
<!--          <div class="flex-grow" />-->
          <el-menu-item index="1">
            <router-link to="/" :underline="false">{{locale[language.code].home.menu.menu1}}</router-link>
          </el-menu-item>
          <el-sub-menu index="2">
            <template v-slot:title>{{locale[language.code].home.menu.menu2}}</template>
            <el-menu-item :index="'2'+item.id" v-for="item in productTypeList" :key="item.id">
              <router-link  :to="'/productgroup/'+item.id" :underline="false">{{item.groupName}}</router-link>
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item index="3">
            <router-link to="/companytechnology" :underline="false">{{locale[language.code].home.menu.menu3}}</router-link>
          </el-menu-item>
          <el-menu-item index="8">
            <a target="_blank" href="https://shop261248634.taobao.com/?spm=pc_detail.30350276.shop_block.dentershop.526313ednNQIr9" >{{locale[language.code].home.menu.menu8}}</a>
          </el-menu-item>
          <el-sub-menu index="4">
<!--            <router-link to="/customercase" :underline="false">{{locale[language.code].home.menu.menu4}}</router-link>-->
            <template v-slot:title>{{locale[language.code].home.menu.menu4}}</template>
            <el-menu-item :index="'4'+item.id" v-for="item in customerGroupList" :key="item.id">
              <router-link  :to="'/customercase/'+item.id" :underline="false">{{item.groupName}}</router-link>
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item index="5">
            <router-link to="/companynews" :underline="false">{{locale[language.code].home.menu.menu5}}</router-link>
          </el-menu-item>
          <el-menu-item index="6">
            <router-link to="/aboutme" :underline="false">{{locale[language.code].home.menu.menu6}}</router-link>
          </el-menu-item>
          <el-menu-item index="7" >
            <router-link to="/contactus" :underline="false">{{locale[language.code].home.menu.menu7}}</router-link>
          </el-menu-item>
        </el-menu>
        <div class="mobile-menu" @click="openMenu()">
          <el-icon size="32">
            <fold />
          </el-icon>
        </div>
      </div>

      <el-drawer
          :title="locale[language.code].app.menuTitle"
          v-model="drawer"
          :direction="'rtl'"
          size="70%"
          destroy-on-close
          >
        <el-menu :default-active="activeIndex"
                 mode="vertical"
                 @select="handleSelect"
        >
          <!--          <el-menu-item index="0">-->
          <!--            <router-link to="/" :underline="false">-->
          <!--            <img-->
          <!--                style="width: 250px"-->
          <!--                src="./assets/kswlogo-login.png"-->
          <!--                alt="酷赛威"-->
          <!--                class="logo-image"-->
          <!--            />-->
          <!--            </router-link>-->
          <!--          </el-menu-item>-->
          <!--          <div class="flex-grow" />-->
          <router-link @click="closeDrawer" to="/" :underline="false">
            <el-menu-item index="1">
              {{locale[language.code].home.menu.menu1}}
            </el-menu-item>
          </router-link>
          <el-sub-menu index="2">
            <template v-slot:title>{{locale[language.code].home.menu.menu2}}</template>
            <router-link @click="closeDrawer" v-for="item in productTypeList" :key="item.id"  :to="'/productgroup/'+item.id" :underline="false">
              <el-menu-item :index="'2'+item.id" >
                {{item.groupName}}
              </el-menu-item>
            </router-link>
          </el-sub-menu>
          <router-link @click="closeDrawer" to="/companytechnology" :underline="false">
            <el-menu-item index="3">
              {{locale[language.code].home.menu.menu3}}
            </el-menu-item>
          </router-link>
          <a target="_blank" href="https://shop261248634.taobao.com/?spm=pc_detail.30350276.shop_block.dentershop.526313ednNQIr9" >
            <el-menu-item index="8">
              {{locale[language.code].home.menu.menu8}}
            </el-menu-item>
          </a>
          <el-menu-item index="4">
            <template v-slot:title>{{locale[language.code].home.menu.menu4}}</template>
            <router-link @click="closeDrawer" v-for="item in productTypeList" :key="item.id"  :to="'/customercase/'+item.id" :underline="false">
              <el-menu-item :index="'4'+item.id" >
                {{item.groupName}}
              </el-menu-item>
            </router-link>
          </el-menu-item>
          <router-link @click="closeDrawer" to="/companynews" :underline="false">
            <el-menu-item index="5">
              {{locale[language.code].home.menu.menu5}}
            </el-menu-item>
          </router-link>
          <router-link @click="closeDrawer" to="/aboutme" :underline="false">
            <el-menu-item index="6">
              {{locale[language.code].home.menu.menu6}}
            </el-menu-item>
          </router-link>
          <router-link @click="closeDrawer" to="/contactus" :underline="false">
            <el-menu-item index="7" >
              {{locale[language.code].home.menu.menu7}}
            </el-menu-item>
          </router-link>
        </el-menu>
      </el-drawer>
      <router-view :key="$route.fullPath" @updateOpen="handleUpdateOpen" :paramsinfo="paramsinfo"  />
      <div class="bottom-page">
        <el-row>
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <div class="page-col">
              <div class="title">{{locale[language.code].home.footer.module1}}</div>
              <div class="content">
                <router-link to="/aboutme" :underline="false">{{locale[language.code].home.footer.module2}}</router-link>
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <div class="page-col">
              <div class="title">{{locale[language.code].home.footer.module3}}</div>
              <div class="content">
                <a v-for="item in productTypeList" :key="item.id">
                  <router-link  :to="'/productgroup/'+item.id" :underline="false">{{item.groupName}}</router-link>
                </a>
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <div class="page-col">
              <div class="title">{{locale[language.code].home.footer.module4}}</div>
              <div class="content">
                <a v-for="item in customerGroupList" :key="item.id">
                  <router-link  :to="'/customercase/'+item.id" :underline="false">{{item.groupName}}</router-link>
                </a>
              </div>
            </div>
          </el-col>
          <el-col :xs="12" :sm="12" :md="12" :lg="6" :xl="6">
            <div class="page-col">
              <div class="title">{{locale[language.code].home.footer.module5}}</div>
              <div class="content">
                <span>{{locale[language.code].home.footer.address}}{{paramsinfo.address}}</span>
                <span>{{locale[language.code].home.footer.contentInfo}}{{paramsinfo.telphone+'&nbsp;&nbsp;'+paramsinfo.phone}}</span>
                <span>{{locale[language.code].home.footer.email}}{{paramsinfo.email}}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="bottom-fooler-div">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <div class="logo-img">
              <img src="./assets/logo-gray.png" class="icp-logo"/>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <div class="icp-info">
              <span style="display: inline-block;margin:0px 15px;">版权所有© 深圳市酷赛威科技有限公司 2026 保留所有权利 <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备2025509454号-1</a></span>
            </div>
          </el-col>
        </el-row>
      </div>
    <el-dialog :title="locale[language.code].app.feedback.title" v-model="open" :width="dialogWidth" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form"  :rules="rules" size="large" label-width="80px">
        <el-row >
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="locale[language.code].app.feedback.feedType" prop="feedbackType">
              <el-select v-model="form.feedbackType" :placeholder="locale[language.code].app.feedback.feedType_tips" clearable>
                <el-option
                    v-for="dict in feedbackTypeList"
                    :key="dict.name"
                    :label="dict.name"
                    :value="dict.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row >
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="locale[language.code].app.feedback.name" prop="customerName">
              <el-input v-model="form.customerName" :placeholder="locale[language.code].app.feedback.name_tips" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="locale[language.code].app.feedback.email" prop="email">
              <el-input v-model="form.email" :placeholder="locale[language.code].app.feedback.email_tips" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row >
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="locale[language.code].app.feedback.phone" prop="contactPhone">
              <el-input v-model="form.contactPhone" :placeholder="locale[language.code].app.feedback.phone_tips" />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-form-item :label="locale[language.code].app.feedback.company" prop="company">
              <el-input v-model="form.company" :placeholder="locale[language.code].app.feedback.company_tips" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="24">
            <el-form-item :label="locale[language.code].app.feedback.content" prop="message">
              <el-input v-model="form.message" :rows="5" type="textarea" :placeholder="locale[language.code].app.feedback.content_tips" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="24">
            <el-form-item :label="locale[language.code].app.feedback.fileName" prop="message">
              <el-upload
                  class="upload-demo"
                  :action="uploadFileUrl"
                  :limit="1"
                  :on-success="handleUploadSuccess"
                  :file-list="form.fileList">
                <el-button size="small" type="primary">{{locale[language.code].app.feedback.fileName}}</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="24">-->
<!--            <el-form-item label="订单文件" prop="dataFile">-->
<!--              <file-upload-->
<!--                  multiple-->
<!--                  :limit="10"-->
<!--                  :file-list="dataFile"-->
<!--                  v-model="form.dataFile"-->
<!--              />-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row >
          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" @click="onSubmit">{{locale[language.code].app.feedback.submit}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <div class="right-affix">
      <div class="right-box-div">
        <el-popover
                    placement="left"
                    :width="200"
                    trigger="hover"
        >
          <div>
            <div>{{locale[language.code].home.footer.email}}</div>
            <span class='email-tips'>{{paramsinfo.email}}</span>
          </div>
          <template #reference>
            <div class="box-info">
              <el-icon size="22">
                <message />
              </el-icon>
              <span>{{locale[language.code].app.emails}}</span>
            </div>
          </template>
        </el-popover>
        <el-popover
            placement="left"
            :width="200"
            trigger="hover"
        >
          <div>
            <div>{{locale[language.code].home.footer.contentInfo}}</div>
            <span class='email-tips'>{{paramsinfo.telphone}}</span>
          </div>
          <template #reference>
            <div class="box-info">
              <el-icon size="22">
                <phone />
              </el-icon>
              <span>{{locale[language.code].app.contactNumber}}</span>
            </div>
          </template>
        </el-popover>
        <div class="box-info" @click="openModel()">
          <el-icon size="22">
            <chat-dot-round />
          </el-icon>

          <span>{{locale[language.code].app.onlineinquiry}}</span>
        </div>
        <div class="box-info" @click="scrollToTop()">
          <el-icon size="22">
            <top />
          </el-icon>
          <span>{{locale[language.code].app.backTop}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { languagelist,producttype ,customergroup,paramsinfo ,addfeedback} from '@/api/Home';
import locale from "@/locale/locale";
import { ElMessage } from 'element-plus';
export default {
  name: 'App',
  components: {
  },
  data(){
    return{
      paramsinfo:{},
      languageList:null,
      uploadFileUrl: process.env.VUE_APP_BASE_API+"file/client/upload", // 上传文件服务器地址
      drawer:false,
      dialogWidth:"70%",
      productTypeList:[],
      customerGroupList:[],
      language:{code:"zh"},
      locale:locale,
      modelTitle:"客户留言",
      feedbackTypeList:[],
      form:{},
      open: false,
      rules: {
        customerName: [
          {required: true, message: "", trigger: "blur"}
        ],
        contactPhone: [
          {required: true, message: "", trigger: "blur"}
        ],
      }
    }
  },
  created() {
    console.log(window.innerWidth)
    if(window.innerWidth <= 720){
      this.dialogWidth = '95%';
    }

    languagelist().then(res =>{
      this.languageList = res.data;
      if(!this.language.name){
        var languageStr = localStorage.getItem("website-language");
        if(!languageStr){
          localStorage.setItem("website-language",JSON.stringify(this.languageList[0]));
        }
        this.initLanguage();
      }
    });
  },
  methods:{
    handleUpdateOpen(open) {
      this.open = open;
    },
    handleUploadSuccess(res) {
      if (res.code === 200) {
        this.form.fileUrl = this.listToString([{ name: res.data.url, url: res.data.url }])
      }else{
        ElMessage.error(this.locale[this.language.code].app.message.uploadErrpr);
        this.form.fileList = [];
      }
    },
    listToString(list, separator) {
      let strs = ""
      separator = separator || ","
      for (let i in list) {
        strs += list[i].url + separator
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : ''
    },
    closeDrawer(){
      this.drawer = false;
    },
    openMenu(){
      this.drawer = true;
    },
    onSubmit(){
      this.$refs["form"].validate(valid => {
            if (valid) {
              this.form.languagesName = this.language.name;
              addfeedback(this.form).then(() =>{
                ElMessage.success(this.locale[this.language.code].app.feedback.addresult);
                this.open = false
              });
            }
      });
    },
    changelanguage(item){
      if(!this.language.id != item.id){
        this.language = item;
        localStorage.setItem("website-language",JSON.stringify(item));
        location.reload();
      }
    },
    openModel(){
      this.reset();
      this.open = true;
    },
    scrollToTop() {
      console.log(this.$refs.scrollContainer);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    initLanguage(){
      var languageStr = localStorage.getItem("website-language");
      if(languageStr){
        this.language = JSON.parse(languageStr);
        this.feedbackTypeList = this.locale[this.language.code].app.feedbackTypeList;
        this.initData();
      }
    },
    //初始化数据
    initData(){
      producttype({id:this.language.id}).then(res => {
        console.log(res);
        this.productTypeList = res.data;
      });

      customergroup({id:this.language.id}).then(res => {
        console.log(res);
        this.customerGroupList = res.data;
      });

      paramsinfo(this.language.id).then(res => {
        console.log(res);
        this.paramsinfo = res.data[0];
      });
    },
    reset() {
      this.form = {
        id: null,
        customerName: null,
        contactPhone: null,
        email: null,
        message: null,
        status: null,
        processor: null,
        processTime: null,
        processRemark: null,
        fileUrl: null,
        company: null,
        feedbackType: null,
        createdBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        isDeleted: null,
        languagesName: null,
        dataFile:null,
        fileList:[]
      }
    },
  }
}
</script>

<style>
html{
  scroll-behavior: smooth;
}

body{
  margin:0px;
}

a{
  color:initial;
}

a:active {
  background-color: transparent;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
a{
  text-decoration: none;
}
.el-menu-item a{
  text-decoration: none;
}

.right-affix{
  text-align: right;
  position: fixed;
  bottom: 200px;
  right:0px;
  box-shadow: 0px 0px 20px 0px #FFFFFF;
  z-index: 200;
  opacity: 0.8;
}

.right-affix .right-box-div{
  display: inline-block;
  background-color: #EFEFEF;
}

.right-affix .right-box-div .box-info{
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding:15px 10px;
  cursor: pointer;
  text-decoration: none;
  border-bottom: 1px solid #FFFFFF;
}

.right-affix .right-box-div .box-info:last-child{
  border-bottom: 0px;
}

.right-affix .right-box-div .box-info:hover{
  background-color: #1890ff;
  color:white;
}

.right-affix .right-box-div .box-info span{
  font-size: 14px;
}

.email-tips{
  color:#1890ff;
  font-weight: bold;
}

.website-contact-container{
  display: flex;
  flex-flow: row nowrap;
  height:30px;
  background-color: #DCDFE6;
  color:#303133;
  font-size: 0.9rem;
  align-items: center;
  padding:5px 22px;
  justify-content: space-between;
}

.menu-index{
  padding:15px 20px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}

.menu-index .el-menu-demo{
  min-width: 1000px;

}

.el-menu--popup-container  .el-menu .el-menu-item{
  padding-left:20px!important;
  padding-right:20px!important;
}



.menu-index .flex-grow {
  width:30px;
}

.menu-index .el-menu--horizontal.el-menu{
  border-bottom: 0px!important;
}

.website-contact-container .right-lang{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.website-contact-container .right-lang .el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  outline: 0px;
}

.menu-index .el-menu .el-menu-item{
  padding:0px 30px;
}

.website-contact-container .contact-info{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.website-contact-container .contact-info .contact{
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin: 0px 10px;
}
@media (min-width: 720px) {
  .mobile-menu{
    display: none;
  }
}
@media (max-width: 720px) {
  .contact-email{
    display: none!important;
  }

  .menu-index .logo-image{
    width: 200px!important;
  }

  .el-menu--vertical{
    border-right: 0px!important;
  }

  .menu-index .el-menu-demo{
    display: none;

  }

  .panel-div{
    padding:20px 10px!important;
  }
  .content-item>>> img{
    display: block;
    margin: 10px auto;
    width:100%;
  }
}



.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.website-contact-container .contact-info .contact span{
  margin-left: 3px;
}
.bottom-fooler-div{
  background-color: #202123;
  position: relative;
  min-height:60px;
}

.bottom-fooler-div .logo-img{
  text-align: center;
  margin-top: 10px;
}
.bottom-fooler-div .logo-img img{
  height:40px;
}

.bottom-fooler-div .icp-info{
  color:#F1F1F1;
  font-size: 13px;
  height:60px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-fooler-div .icp-info a{
  color:#F1F1F1;
}

.home-index-product{
  padding:45px 20px;
}

.home-index-product:nth-child(odd){
  background-color: #F5f5f5;
}

.home-index-product .index-title{
  font-weight: bold;
  font-size: 2rem;
  color:#303133;
}
.home-index-product .product-body{
  padding:4px 6px;
}
.home-index-product .product-body  .img-div{
  border:1px solid #E4E7ED;
  padding:8px 12px;
  border-radius: 6px;
}
.home-index-product .product-body .img-div img{
  width:100%;
}

.descrption-div{
  height:300px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}

.descrption-img{
  height:300px;
}

.descrption-img img{
  height: 100%;
  max-width: 100%;

}

.descrption-div .descrption-title{
  font-weight: bold;
  font-size: 2rem;
  color:#303133;
}

.descrption-div .descrption-info{
  text-align: left;
  text-indent:2rem;
  word-spacing: 4px;
  color:#363636;
}

.technology-div{
  margin:40px 15px;
  color:#303133;
}

.technology-div p{
  font-weight: bold;
}
.technology-div .info{
  text-align: left;
  text-indent:2rem;
  color:#909399;
  font-size: 14px;
}
.technology-item{
  margin:10px 18px;
}
.technology-item img{
  width: 100%;
  border:1px solid #F5f5f5;
  box-shadow: 0px 0px 15px 0px #F1F1F1;
}

.technology-info{
  margin:10px 18px;
}

.technology-info .title{
  font-weight: bold;
  text-align:left;
}

.technology-info .info{
  font-size: 14px;
  text-align: left;
}


.carousel-div{
  width:100%;
}

.carousel-div .carousel-img{
  width:100%;
}

.custom-div{
  margin:10px 0px;
}

.bottom-page{
  padding:35px 20px;
  background-color: #505050;
}

.bottom-page .page-col{
  text-align: left;
  color:#eee;
}

.bottom-page .page-col .title{
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;

}

.bottom-page .page-col .content{
  font-size: 14px;
  color:#eee;
  display: flex;
  flex-flow: column nowrap;
}

.bottom-page .page-col .content a{
  color:#eee;
  text-decoration: none;
  margin: 4px;
}

.banner-image{
  width:100%;
}
</style>